// extracted by mini-css-extract-plugin
export default {"nav":"nav--CYYVi","header":"header--CYYVi","backButton":"backButton--CYYVi","emptyButton":"emptyButton--CYYVi"};